import * as Analytics from "../../../lib/TrellisAnalytics";
import * as React from "react";
import { FullWidthForm, LabelButton } from "../../../components/Styles/Styles";
import usePageEvent from "../../../hooks/usePageEvent";
export function MFASelection(_a) {
    var _b;
    var selectedIssuer = _a.selectedIssuer, challengeData = _a.challengeData, handleOptionSelected = _a.handleOptionSelected;
    var page = usePageEvent();
    function handleOptionSelect(event, optionIndex) {
        event.preventDefault();
        handleOptionSelected(optionIndex);
    }
    React.useEffect(function () {
        page(Analytics.PAGES.MFASELECTION);
    }, [page]);
    return (React.createElement(FullWidthForm, null,
        selectedIssuer ? (React.createElement("div", { className: "mb-4 flex text-sm leading-normal" },
            React.createElement("p", null,
                "Please select from one of the below options to receive your one time passcode to log into ",
                selectedIssuer.name))) : null,
        React.createElement("div", { className: "self-stretch text-sm leading-normal" },
            React.createElement("ul", null, (_b = challengeData === null || challengeData === void 0 ? void 0 : challengeData.options) === null || _b === void 0 ? void 0 : _b.map(function (option, index) { return (React.createElement("li", { key: index },
                React.createElement(LabelButton, { className: "submit pure-button pure-button-primary", type: "submit", onClick: function (event) { return handleOptionSelect(event, index); } }, option))); })))));
}
